// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GgJ63zqpjRSDsDEJe7gzYg\\=\\={width:100%;box-shadow:var(--xds-elevation-03);background-color:var(--xds-color-container-default);color:var(--xds-color-content-default);display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:1;height:72px;padding:32px 16px;font-size:16px}@media only screen and (max-width: 1028px){.GgJ63zqpjRSDsDEJe7gzYg\\=\\={height:auto;flex-wrap:wrap}}@media(min-width: 600px){.GgJ63zqpjRSDsDEJe7gzYg\\=\\={flex-direction:row;justify-content:space-between;padding:21px 16px}}.Dt2yI-A66svrMU7sNcC2iQ\\=\\={width:240px;margin-bottom:var(--xds-spacing-a);margin-right:var(--xds-spacing-e)}@media only screen and (max-width: 1028px){.Dt2yI-A66svrMU7sNcC2iQ\\=\\={margin-right:auto;margin-left:auto;margin-bottom:var(--xds-spacing-g)}}.sZBFXbzpp43ttfmOwHmKmg\\=\\={font-weight:bold}@media only screen and (max-width: 1028px){.sZBFXbzpp43ttfmOwHmKmg\\=\\={margin-left:auto;margin-right:auto;margin-bottom:30px}}.S6KdPkci97mmvJU-8wrcLg\\=\\={display:flex;justify-content:space-between;align-items:center;width:100%;flex-direction:column}@media(min-width: 600px){.S6KdPkci97mmvJU-8wrcLg\\=\\={flex-direction:row}}@media only screen and (max-width: 1028px){.S6KdPkci97mmvJU-8wrcLg\\=\\={flex-wrap:wrap;flex-direction:row}}._2F\\+0jRrTym0FhtW4J65jqQ\\=\\={padding:0;align-items:center;list-style:none;display:flex}@media only screen and (max-width: 1028px){._2F\\+0jRrTym0FhtW4J65jqQ\\=\\={flex-direction:row;flex-wrap:wrap;width:100%}}._2F\\+0jRrTym0FhtW4J65jqQ\\=\\= li{margin-right:var(--xds-spacing-e)}@media only screen and (max-width: 1028px){._2F\\+0jRrTym0FhtW4J65jqQ\\=\\= li{margin-bottom:var(--xds-spacing-e);margin-right:0px;display:flex;flex-direction:column;flex-basis:50% !important;flex:1;text-align:center}}._2F\\+0jRrTym0FhtW4J65jqQ\\=\\= li a{text-decoration:none;color:var(--xds-color-content-default)}._2F\\+0jRrTym0FhtW4J65jqQ\\=\\= li a.mAZyVUItlS2xpLpNwfY5mw\\=\\={text-decoration:underline}._2F\\+0jRrTym0FhtW4J65jqQ\\=\\= li a:hover{cursor:pointer;text-decoration:underline}", "",{"version":3,"sources":["webpack://./src/shared/components/Footer/Footer.module.scss"],"names":[],"mappings":"AAEA,4BACE,UAAA,CACA,kCAAA,CACA,mDAAA,CACA,sCAAA,CACA,YAAA,CACA,qBAAA,CACA,kBAAA,CACA,sBAAA,CACA,SAAA,CACA,WAAA,CACA,iBAAA,CACA,cAAA,CAEA,2CAdF,4BAeI,WAAA,CACA,cAAA,CAAA,CAGF,yBAnBF,4BAoBI,kBAAA,CACA,6BAAA,CACA,iBAAA,CAAA,CAIJ,4BACE,WAAA,CACA,kCAAA,CACA,iCAAA,CAEA,2CALF,4BAMI,iBAAA,CACA,gBAAA,CACA,kCAAA,CAAA,CAIJ,4BACE,gBAAA,CAEA,2CAHF,4BAII,gBAAA,CACA,iBAAA,CACA,kBAAA,CAAA,CAIJ,4BACE,YAAA,CACA,6BAAA,CACA,kBAAA,CACA,UAAA,CACA,qBAAA,CAEA,yBAPF,4BAQI,kBAAA,CAAA,CAGF,2CAXF,4BAYI,cAAA,CACA,kBAAA,CAAA,CAIJ,8BACE,SAAA,CACA,kBAAA,CACA,eAAA,CACA,YAAA,CAEA,2CANF,8BAOI,kBAAA,CACA,cAAA,CACA,UAAA,CAAA,CAGF,iCACE,iCAAA,CAEA,2CAHF,iCAII,kCAAA,CACA,gBAAA,CACA,YAAA,CACA,qBAAA,CACA,yBAAA,CACA,MAAA,CACA,iBAAA,CAAA,CAGF,mCACE,oBAAA,CACA,sCAAA,CAEA,8DACE,yBAAA,CAGF,yCACE,cAAA,CACA,yBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundDefault": "#fcfcfc",
	"backgroundDark": "#1a1a19",
	"containerSubtle": "#f5f3f1",
	"containerDark": "#262626",
	"borderDefault": "#efedea",
	"containerInverse": "#262626",
	"containerDefault": "#fff",
	"borderStrong": "#dbd9d7",
	"dividerDefault": "rgba(0,0,0,.08)",
	"dividerInverse": "hsla(0,0%,100%,.2)",
	"borderInverse": "#575655",
	"interactiveBrand": "#f36805",
	"interactivePrimary": "#262626",
	"interactiveInverse": "#fff",
	"interactiveSecondary": "#f5f3f1",
	"interactiveLight": "#fff",
	"supportError": "#d50525",
	"supportDarkError02": "#491e24",
	"overlay": "rgba(0,0,0,.55)",
	"supportPositive": "#017a39",
	"interactiveForm": "#797876",
	"supportWarning": "#f6c243",
	"supportInfo": "#125fca",
	"supportNeutral": "#efedea",
	"supportWarning02": "#fff9df",
	"supportError02": "#ffe9ea",
	"supportInfoInverse": "#7aadf6",
	"supportPositive02": "#e5faef",
	"supportInfo02": "#ebf6fa",
	"containerStrong": "#efedea",
	"supportPositiveInverse": "#22bf65",
	"supportBrand01": "#ff8000",
	"supportBrand03": "#c1dade",
	"supportBrand04": "#f2a6b0",
	"supportBrand06": "#5b3d5b",
	"supportBrand07": "#f75e28",
	"supportBrand05": "#f6c243",
	"contentDefault": "#242e30",
	"contentSubdued": "#3c4c4f",
	"contentInteractiveLight": "#fff",
	"contentInteractiveBrand": "#f36805",
	"contentInteractivePrimary": "#fff",
	"contentInteractiveSecondary": "#242e30",
	"contentInteractiveInverse": "#242e30",
	"contentInteractiveDark": "#242e30",
	"contentInteractiveTertiary": "#303d3f",
	"contentLight": "#fff",
	"contentInteractiveError": "#d50525",
	"contentLink": "#242e30",
	"contentInverse": "#fff",
	"contentLinkDistinct": "#125fca",
	"contentLinkLight": "#fff",
	"backgroundSubtle": "#f5f3f1",
	"contentError": "#d50525",
	"contentLinkVisited": "purple",
	"contentLinkVisitedInverse": "#c58af9",
	"contentDisabled": "#8c999b",
	"contentLinkInverse": "#fff",
	"contentBrand": "#f36805",
	"hover02": "8%",
	"active01": "12%",
	"hover01": "4%",
	"focus": "#fff",
	"focusOuter": "#094dac",
	"active02": "20%",
	"skeleton01": "#f5f3f1",
	"disabled01": "#efedea",
	"supportBrand02": "#ffead4",
	"skeleton02": "#efedea",
	"contentPositive": "#017a39",
	"borderSubtle": "#f5f3f1",
	"footerSection": "GgJ63zqpjRSDsDEJe7gzYg==",
	"companyLogo": "Dt2yI-A66svrMU7sNcC2iQ==",
	"copyright": "sZBFXbzpp43ttfmOwHmKmg==",
	"legalLinks": "S6KdPkci97mmvJU-8wrcLg==",
	"legalLinksWrapper": "_2F+0jRrTym0FhtW4J65jqQ==",
	"active": "mAZyVUItlS2xpLpNwfY5mw=="
};
export default ___CSS_LOADER_EXPORT___;
